import {
  constructApartmentName,
  translatei18nDB,
} from "./hoasFavouritesHelpers";

const tampuuriWindowObject = () => {
  const translate = (string = null) => {
    //Uses polylang directly --> City == Kaupunki etc.
    if (window["hoasTampuuri"][string] !== undefined) {
      return window["hoasTampuuri"][string];
    }

    return string;
  };

  const getDefaultImageApartment = () => {
    if (window["hoasTampuuri"]["defaultImageApartment"] !== undefined) {
      return window["hoasTampuuri"]["defaultImageApartment"];
    }

    return null;
  };

  const getDefaultImageCostUnit = () => {
    if (window["hoasTampuuri"]["defaultImageCostUnit"] !== undefined) {
      return window["hoasTampuuri"]["defaultImageCostUnit"];
    }

    return null;
  };

  const getInfoText = (key) => {
    //Key == property or apartment
    if (window["hoasTampuuri"]["infoText"][key] !== undefined) {
      return window["hoasTampuuri"]["infoText"][key];
    }

    return null;
  };

  const getAttentionBanner = () => {
    if (window["hoasTampuuri"]["attentionBanner"] !== undefined) {
      return window["hoasTampuuri"]["attentionBanner"];
    }

    return null;
  };

  const getCityAreaAddress = () => {
    if (
      window["hoasTampuuri"]["searchparams"]["city_area_address"] !== undefined
    ) {
      let object = window["hoasTampuuri"]["searchparams"]["city_area_address"];
      return object;
    }

    return {};
  };

  const getExtraInfos = () => {
    if (
      window["hoasTampuuri"]["searchparams"]["extra_infos_and_rental_types"][
        "extra_infos"
      ] !== undefined
    ) {
      return window["hoasTampuuri"]["searchparams"][
        "extra_infos_and_rental_types"
      ]["extra_infos"];
    }

    return {};
  };

  const getRentalTypes = () => {
    if (
      window["hoasTampuuri"]["searchparams"]["extra_infos_and_rental_types"][
        "rental_types"
      ] !== undefined
    ) {
      return window["hoasTampuuri"]["searchparams"][
        "extra_infos_and_rental_types"
      ]["rental_types"];
    }

    return {};
  };

  const getCachedResults = () => {
    if (window["hoasTampuuri"]["cached_results"] !== undefined) {
      return window["hoasTampuuri"]["cached_results"];
    }

    return null;
  };

  const getSvgs = () => {
    if (window["hoasTampuuri"]["svgElements"] !== undefined) {
      return window["hoasTampuuri"]["svgElements"];
    }

    return null;
  };

  const getFrontpageHeroCache = () => {
    if (window["hoasTampuuri"]["cached_fp_count"] !== undefined) {
      return window["hoasTampuuri"]["cached_fp_count"];
    }

    return null;
  };

  const getArchiveURL = () => {
    if (window["hoasTampuuri"]["archive_url"] !== undefined) {
      return window["hoasTampuuri"]["archive_url"];
    }

    return null;
  };

  const getFpHeroTranslationMap = () => {
    if (window["hoasTampuuri"]["translationMap"] !== undefined) {
      return window["hoasTampuuri"]["translationMap"];
    }

    return null;
  };

  return {
    translate,
    translatei18nDB: translatei18nDB,
    getDefaultImageApartment,
    getDefaultImageCostUnit,
    getInfoText,
    getAttentionBanner,
    getExtraInfos,
    getRentalTypes,
    getCachedResults,
    getCityAreaAddress,
    constructApartmentName: constructApartmentName,
    getSvgs,
    getFrontpageHeroCache,
    getArchiveURL,
    getFpHeroTranslationMap,
  };
};

export default tampuuriWindowObject;
